import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import FirstCardCelebration from "./FirstCardCelebration";
import ROUTES from "../router/routesModel";

/**
 * Wraps the celebration with navigation (must sit under Router).
 *
 * When the first card landed in the Vault (`collectionType === "glory"`), the
 * primary action is "List it for trade": it opens the Collection page with that
 * card's listing dialog preset to the Trade Binder (`?list=<catalog card id>`,
 * handled by CollectionPage). P0 area B, docs/LAUNCH_REMEDIATION_2026-09-26.md.
 */
const FirstCardCelebrationHost = ({ open, onClose, imageUrl, cardName, cardId, collectionType }) => {
  const navigate = useNavigate();
  const onFindTraders = useCallback(() => {
    navigate(ROUTES.MAP);
  }, [navigate]);
  const onListForTrade = useCallback(() => {
    navigate(`${ROUTES.COLLECTION}?list=${encodeURIComponent(String(cardId))}`);
  }, [navigate, cardId]);

  const firstCardIsInVault = collectionType === "glory" && Boolean(cardId);

  return (
    <FirstCardCelebration
      open={open}
      onClose={onClose}
      onFindTraders={onFindTraders}
      onListForTrade={firstCardIsInVault ? onListForTrade : undefined}
      imageUrl={imageUrl}
      cardName={cardName}
    />
  );
};

export default FirstCardCelebrationHost;
